import React from 'react';
import { Redirect, Route, useLocation, useRouteMatch } from 'react-router-dom';
import AgentHierarchy from './agentHierarchy/agentHierarchy.component';

// const roleService = new RoleService();

export default function AgentHierarchyRoutersComponent() {
  const { path } = useRouteMatch();
  const location = useLocation();

  //   const hasAccess = roleService.checkRouteAccess({ location });
  const hasAccess = true;

  return hasAccess ? (
    <Route exact path={path} component={AgentHierarchy} />
  ) : (
    <Redirect
      to={{
        pathname: '/unauthorized',
        state: { from: location },
      }}
    />
  );
}
